const samenstellenItems = [
  { title: 'Aanspreking', path: '/Aanspreking' },
  { title: 'Aard van de plechtigheid', path: '/AardVanDePlechtigheid' },
  { title: 'Symboliek', path: '/Symboliek' },
  { title: 'Muziek', path: '/Muziek' },
  { title: "Foto's", path: '/Fotos' },
  { title: 'Eigen teksten/getuigenissen', path: '/Teksten' },
  { title: 'Kernwoorden', path: '/Kernwoorden' },
  { title: 'Levensverhaal', path: '/Levensverhaal' },
  { title: 'Praktische afspraken', path: '/PraktischeAfspraken' },
  { title: 'Extra/opmerkingen', path: '/ExtraOpmerkingen' }
]

export default {
  computed: {
    samenstellenNavigation_CurrentIndex () {
      return samenstellenItems.findIndex(item => item.path === this.$route.path)
    },
    samenstellenNavigation_PreviousItem () {
      const index = this.samenstellenNavigation_CurrentIndex
      if (index <= 0) return null
      const item = samenstellenItems[index - 1]
      return { ...item, disabled: !item.path }
    },
    samenstellenNavigation_NextItem () {
      const index = this.samenstellenNavigation_CurrentIndex
      if (index < 0 || index >= samenstellenItems.length - 1) return null
      const item = samenstellenItems[index + 1]
      return { ...item, disabled: !item.path }
    }
  },
  methods: {
    samenstellenNavigation_GoToPrevious () {
      const item = this.samenstellenNavigation_PreviousItem
      if (item && !item.disabled) {
        this.$router.push(item.path)
      }
    },
    samenstellenNavigation_GoToNext () {
      const item = this.samenstellenNavigation_NextItem
      if (item && !item.disabled) {
        this.$router.push(item.path)
      }
    }
  }
}
